import { render, staticRenderFns } from "./metrics_ai_detection_chart.vue?vue&type=template&id=32163b83&scoped=true&"
import script from "./metrics_ai_detection_chart.vue?vue&type=script&lang=js&"
export * from "./metrics_ai_detection_chart.vue?vue&type=script&lang=js&"
import style0 from "./metrics_ai_detection_chart.vue?vue&type=style&index=0&id=32163b83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32163b83",
  null
  
)

export default component.exports